var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmvIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 4.47715 8.47715 0 14 0C19.5228 0 24 4.47715 24 10C24 15.5228 19.5228 20 14 20C8.47715 20 4 15.5228 4 10Z",
    fill: "#5062F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5597 10.977C10.6037 10.977 10.6427 10.994 10.6767 11.028L10.9947 11.373C10.8187 11.591 10.6017 11.758 10.3437 11.874C10.0877 11.99 9.77966 12.048 9.41966 12.048C9.09766 12.048 8.80766 11.993 8.54966 11.883C8.29366 11.773 8.07466 11.62 7.89266 11.424C7.71066 11.228 7.57066 10.994 7.47266 10.722C7.37666 10.45 7.32866 10.153 7.32866 9.831C7.32866 9.505 7.38066 9.207 7.48466 8.937C7.58866 8.665 7.73466 8.431 7.92266 8.235C8.11266 8.039 8.33866 7.887 8.60066 7.779C8.86266 7.669 9.15266 7.614 9.47066 7.614C9.78666 7.614 10.0667 7.666 10.3107 7.77C10.5567 7.874 10.7657 8.01 10.9377 8.178L10.6677 8.553C10.6517 8.577 10.6307 8.598 10.6047 8.616C10.5807 8.634 10.5467 8.643 10.5027 8.643C10.4727 8.643 10.4417 8.635 10.4097 8.619C10.3777 8.601 10.3427 8.58 10.3047 8.556C10.2667 8.53 10.2227 8.502 10.1727 8.472C10.1227 8.442 10.0647 8.415 9.99866 8.391C9.93266 8.365 9.85566 8.344 9.76766 8.328C9.68166 8.31 9.58166 8.301 9.46766 8.301C9.27366 8.301 9.09566 8.336 8.93366 8.406C8.77366 8.474 8.63566 8.574 8.51966 8.706C8.40366 8.836 8.31366 8.996 8.24966 9.186C8.18566 9.374 8.15366 9.589 8.15366 9.831C8.15366 10.075 8.18766 10.292 8.25566 10.482C8.32566 10.672 8.41966 10.832 8.53766 10.962C8.65566 11.092 8.79466 11.192 8.95466 11.262C9.11466 11.33 9.28666 11.364 9.47066 11.364C9.58066 11.364 9.67966 11.358 9.76766 11.346C9.85766 11.334 9.93966 11.315 10.0137 11.289C10.0897 11.263 10.1607 11.23 10.2267 11.19C10.2947 11.148 10.3617 11.097 10.4277 11.037C10.4477 11.019 10.4687 11.005 10.4907 10.995C10.5127 10.983 10.5357 10.977 10.5597 10.977ZM16.2515 7.662V12H15.5405V9.198C15.5405 9.086 15.5465 8.965 15.5585 8.835L14.2475 11.298C14.1855 11.416 14.0905 11.475 13.9625 11.475H13.8485C13.7205 11.475 13.6255 11.416 13.5635 11.298L12.2375 8.826C12.2435 8.892 12.2485 8.957 12.2525 9.021C12.2565 9.085 12.2585 9.144 12.2585 9.198V12H11.5475V7.662H12.1565C12.1925 7.662 12.2235 7.663 12.2495 7.665C12.2755 7.667 12.2985 7.672 12.3185 7.68C12.3405 7.688 12.3595 7.701 12.3755 7.719C12.3935 7.737 12.4105 7.761 12.4265 7.791L13.7255 10.2C13.7595 10.264 13.7905 10.33 13.8185 10.398C13.8485 10.466 13.8775 10.536 13.9055 10.608C13.9335 10.534 13.9625 10.463 13.9925 10.395C14.0225 10.325 14.0545 10.258 14.0885 10.194L15.3695 7.791C15.3855 7.761 15.4025 7.737 15.4205 7.719C15.4385 7.701 15.4575 7.688 15.4775 7.68C15.4995 7.672 15.5235 7.667 15.5495 7.665C15.5755 7.663 15.6065 7.662 15.6425 7.662H16.2515ZM20.9363 7.662L19.1843 12H18.4553L16.7033 7.662H17.3513C17.4213 7.662 17.4783 7.679 17.5223 7.713C17.5663 7.747 17.5993 7.791 17.6213 7.845L18.6443 10.491C18.6783 10.577 18.7103 10.672 18.7403 10.776C18.7723 10.878 18.8023 10.985 18.8303 11.097C18.8543 10.985 18.8803 10.878 18.9083 10.776C18.9363 10.672 18.9673 10.577 19.0013 10.491L20.0183 7.845C20.0343 7.799 20.0653 7.757 20.1113 7.719C20.1593 7.681 20.2173 7.662 20.2853 7.662H20.9363Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmvIcon);
export default __webpack_public_path__ + "static/media/cmvIcon.e57c3f3f0b2c4b3b09eb194f98a0ede3.svg";
export { ForwardRef as ReactComponent };